import React from 'react';
import Header from '../Header';
import { Box } from '@mui/material';
import CoreDevicesTable from '../tables/CoreDevicesTable';
import Typography from '@mui/material/Typography';
import BrokenLinkPage from './BrokenLinkPage';
import { useParams } from 'react-router-dom';
import { CoreNameDataType } from '../../types/buildingTypes';
import { useUserContext } from '../../context/userConext';
import { useRequiredSearchParams } from '../../hooks/useRequiredSearchParams';
import DynamicBreadcrumbs from '../breadcrumbs/DynamicBreadcrumbs';
import pageStyles from './pageStyles';

function CoreDhcpDevicesPage() {
  const { core } = useParams<CoreNameDataType>();
  const { params, isValid } = useRequiredSearchParams(['vendor', 'site', 'region', 'building']);
  const { user_permissions } = useUserContext();

  if (!isValid || !core) return <BrokenLinkPage />;

  return (
    <>
      <Header />
      {
        <Box sx={{ margin: 'auto', width: '80%' }}>
          <Box sx={pageStyles.dynamicBreadcrumbs}>
            <DynamicBreadcrumbs />
          </Box>
          <Typography sx={pageStyles.label} component="h1" variant="h4" align="center">
            Core manager - IP: {core}, Region: {params.region}
          </Typography>
          <CoreDevicesTable
            device="core-dhcp"
            deviceIP={core}
            selectedVendor={params.vendor}
            selectedSite={params.site}
            selectedRegion={params.region}
            selectedBuilding={params.building}
            isDhcpRole={true}
            hasPermissionsToCreateDhcpReservation={
              user_permissions.dhcp_reservation_create_permission
            }
            hasPermissionsToUpdateDhcpReservation={
              user_permissions.dhcp_reservation_update_permission
            }
            hasPermissionsToDeleteDhcpReservation={
              user_permissions.dhcp_reservation_delete_permission
            }
            hasPermissionsToBulkCreateDhcpReservation={
              user_permissions.dhcp_reservations_batch_create_permission
            }
          />
        </Box>
      }
    </>
  );
}

export default CoreDhcpDevicesPage;
